// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"453":"0a6399e2","553":"6d8a1512"}[chunkId] + ".css";
};